<template>
  <div class="m-l-50 m-t-30 w-800">
    <el-form ref="form" :model="form" :rules="rules" label-width="150px">
      <el-form-item label="企业简称" prop="company_name">
        <el-input v-model.trim="form.company_name" placeholder="请输入企业简称" clearable class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="企业全称" prop="rise_company_name">
        <el-input v-model.trim="form.rise_company_name" placeholder="请输入企业全称" clearable class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="纳税人识别号" prop="rise_discern_code">
        <el-input v-model.trim="form.rise_discern_code" placeholder="请输入纳税人识别号" clearable class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="企业注册地址" prop="rise_company_addr">
        <el-input v-model.trim="form.rise_company_addr" placeholder="请输入企业注册地址" clearable class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="企业联系电话" prop="rise_company_phone">
        <el-input v-model.trim="form.rise_company_phone" placeholder="请输入企业联系电话" v-on:change="set_phone()" clearable class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="开户行名称" prop="rise_bank_name">
        <el-input v-model.trim="form.rise_bank_name" placeholder="请输入开户行名称" clearable class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="开户银行账号" prop="rise_bank_code">
        <el-input v-model.trim="form.rise_bank_code" placeholder="请输入开户银行账号" clearable class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="纳税人性质" prop="vat_type" class="w-500">
        <el-radio-group v-model="form.vat_type">
          <el-radio :label="1">小规模纳税人</el-radio>
          <el-radio :label="2">一般纳税人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="企业超级管理员" prop="username">
        <el-input v-model.trim="form.username" clearable class="h-40 w-400" placeholder="请输入手机号"></el-input>
        <el-tooltip class="item" effect="dark" content="若该用户未注册，则自动注册；若该用户已注册，自动绑定到该用户下" placement="right">
          <el-button size="small" class="el-icon-warning">  提示</el-button>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="姓名" prop="user_name">
        <el-input v-model.trim="form.user_name" placeholder="请输入姓名" clearable class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="允许使用模块">
        <el-checkbox-group v-model="form.mokuai">
          <el-checkbox v-for="item in mokuai" :label="item.id">{{item.menu_name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item class="m-t-30">
        <el-button type="primary" @click="add()" :loading="isLoading" size="small">提 交</el-button>
        <el-button @click="goback()" size="small">返 回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<style>
  .form-checkbox:first-child{
    margin-left: 15px;
  }
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'

  export default {
    data() {
      return {
        isLoading: false,
        mokuai: [],
        form: {
          company_name: '',
          rise_company_name: '',
          rise_discern_code: '',
          rise_company_addr: '',
          rise_company_phone: '',
          rise_bank_name: '',
          rise_bank_code: '',
          vat_type: 1,
          username: '',
          user_name: '',
          mokuai: [2, 3, 5, 6, 7, 8],
          id: this.$route.params.id
        },
        rules: {
          company_name: [
            { required: true, message: '请填写企业名称' }
          ],
          rise_company_name: [
            { required: true, message: '请填写企业全称' }
          ],
          rise_discern_code: [
            { required: true, message: '请填写纳税人识别号' }
          ],
          rise_company_addr: [
            { required: true, message: '请填写企业注册地址' }
          ],
          rise_company_phone: [
            { required: true, message: '请填写企业联系电话' }
          ],
          rise_bank_name: [
            { required: true, message: '请填写开户行名称' }
          ],
          rise_bank_code: [
            { required: true, message: '请填写开户银行账号' }
          ],
          vat_type: [
            { required: true, message: '请选择纳税人性质' }
          ],
          username: [
            { required: true, message: '请填写手机号' }
          ],
          user_name: [
            { required: true, message: '请填写姓名' }
          ]
        }
      }
    },
    methods: {
      add(form) {
        console.log('res = ', _g.j2s(this.form))
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/company', this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '添加成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      get_mokuai() {
        this.apiGet('admin/base/mokuai_list').then((res) => {
          this.handelResponse(res, (data) => {
            this.mokuai = data.list
            this.form.mokuai = data.check_list
          })
        })
      },
      set_phone() {
        if (!this.form.username) {
          this.form.username = this.form.rise_company_phone
        }
      }
    },
    created() {
      _g.closeGlobalLoading()
      this.get_mokuai()
    },
    components: {
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// add.vue?486fdb79